module.exports = __webpack_public_path__ + "img/logo01.fc9f0613.png";